// extracted by mini-css-extract-plugin
export var found = "WasteItem-module--found--nYaxB";
export var iconWrapper = "WasteItem-module--iconWrapper--vHX3t";
export var imageWrapper = "WasteItem-module--imageWrapper--ZCFwz";
export var noItems = "WasteItem-module--noItems--1zmzl";
export var noteOrderStatus = "WasteItem-module--noteOrderStatus--mjRy+";
export var notfound = "WasteItem-module--notfound--pCr6Q";
export var statusBulb = "WasteItem-module--statusBulb--pFVq5";
export var wasteItem = "WasteItem-module--wasteItem--3atYu";